import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'are_onsite_canteens_eating_areas_line_legal_requirements'

export const dataPointDefinition = {
  retracedId: 'are_onsite_canteens_eating_areas_line_legal_requirements',
  name: 'Are onsite canteens and eating areas in line with legal requirements?',
  description:
    'Consult applicable legal requirements relating to having and maintaining an eating area and kitchen (e.g. legal requirements to have a canteen depending on size of workforce, separation from work area, space/number of seats, toilet, canteen staff, work clothes, fire safety, storage of food, tidiness',
  meta: {
    slcpMeta: {
      key: 'hs-56--1',
      number: 'HS-CAN-1',
      masterType: 'Question',
      versionImported: '1.7.0',
    },
  },
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'hs-56--1', version: '1.7.0', provider: 'slcp'}],
  sortingId: 29400,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
